import { useCallback } from 'react'
import CertificateListService from '../services/CertificateListService'
import { CertificateDocumentStatus } from '../enums/CertificateDocumentStatus'
import {
  IEcmCertificateDocument,
  IEcmCertificateDocumentActionRequest,
} from '../pages/certificate-list-view/cetificate-list/add-new-certificate/rp-library/shared/interfaces/IEcmCertificateDocument'
import { ecmUnavailableHeader, ecmUnavailableMessage } from '../utils/constants/ecm.constants'
import useToastr from './useToastr'

const useCertificateDocument = () => {
  const { showError, showSuccess, showWarning } = useToastr()

  const handleLinkToWb = useCallback(async (props: IEcmCertificateDocumentActionRequest) => {
    const { certificateDocumentId, ecmFileNodeId, certificateId, handleUpdateDocumentsStatus } =
      props

    handleUpdateDocumentsStatus(
      CertificateDocumentStatus.UploadToEcmInProgress,
      certificateDocumentId
    )

    const payload: IEcmCertificateDocument = {
      certificateDocumentId: certificateDocumentId,
      ecmFileNodeId: ecmFileNodeId ?? '',
      isTestReportDuplicate: false,
      workbenchCertificateId: certificateId ?? '',
    }

    await CertificateListService.linkWb(payload)
      .then((response: any) => {
        if (response?.isSuccess) {
          showSuccess('Success!', 'The document(s) has been uploaded to Workbench successfully.')
          handleUpdateDocumentsStatus(
            CertificateDocumentStatus.LinkedToWbAndEcmTic,
            certificateDocumentId
          )
        } else {
          showWarning(ecmUnavailableHeader, ecmUnavailableMessage)
          handleUpdateDocumentsStatus(
            CertificateDocumentStatus.SavedInEcmTic,
            certificateDocumentId
          )
        }
      })
      .catch((error: any) => {
        const errorMessage = error?.response?.data?.message ?? ecmUnavailableMessage
        showError('Error!', errorMessage)
        handleUpdateDocumentsStatus(CertificateDocumentStatus.SavedInEcmTic, certificateDocumentId)
      })
  }, [])

  const handleUnlinkToWb = useCallback(
    async (props: IEcmCertificateDocumentActionRequest) => {
      const { certificateDocumentId, ecmFileNodeId, certificateId, handleUpdateDocumentsStatus } =
        props

      handleUpdateDocumentsStatus(
        CertificateDocumentStatus.UnlinkingInProgress,
        certificateDocumentId
      )

      const payload: IEcmCertificateDocument = {
        certificateDocumentId: certificateDocumentId,
        ecmFileNodeId: ecmFileNodeId,
        isTestReportDuplicate: false,
        workbenchCertificateId: certificateId,
      }

      await CertificateListService.unlinkEcmDocument(payload)
        .then(response => {
          if (response?.isSuccess) {
            showSuccess('Success!', 'The document(s) has been unlinked from Workbench successfully')
            handleUpdateDocumentsStatus(
              CertificateDocumentStatus.SavedInEcmTic,
              certificateDocumentId
            )
          } else {
            showWarning(ecmUnavailableHeader, ecmUnavailableMessage)
            handleUpdateDocumentsStatus(
              CertificateDocumentStatus.LinkedToWbAndEcmTic,
              certificateDocumentId
            )
          }
        })
        .catch(error => {
          const errorMessage = error?.response?.data?.message ?? ecmUnavailableMessage
          showError('Error!', errorMessage)
          handleUpdateDocumentsStatus(
            CertificateDocumentStatus.LinkedToWbAndEcmTic,
            certificateDocumentId
          )
        })
    },

    []
  )

  return { handleUnlinkToWb, handleLinkToWb }
}

export default useCertificateDocument
